import React from "react";
import {
  FolderIcon,
  PencilIcon,
  ArrowUpTrayIcon,
  TrashIcon,
} from "@heroicons/react/24/outline";
import { Folder } from "../types";

interface FolderCardProps {
  folder: Folder;
  onNavigate: (folder: Folder) => void;
  onEdit: (folder: Folder) => void;
  onMove: (folder: Folder) => void;
  onDelete: (folder: Folder) => void;
}

const FolderCard: React.FC<FolderCardProps> = ({
  folder,
  onNavigate,
  onEdit,
  onMove,
  onDelete,
}) => {
  return (
    <div
      className="bg-gradient-to-br from-white to-gray-50 overflow-hidden shadow-xl rounded-2xl hover:shadow-xl transition-all duration-300 cursor-pointer group transform hover:-translate-y-1"
      onClick={() => onNavigate(folder)}
    >
      <div className="p-3 lg:p-4">
        <div className="flex items-center">
          <div className="bg-gradient-to-r from-blue-500 to-purple-600 rounded-xl p-2.5 mr-3 lg:mr-3.5 flex-shrink-0 shadow-lg">
            <FolderIcon className="h-5 w-5 lg:h-6 lg:w-6 text-white" />
          </div>
          <div className="flex-1 min-w-0 transition-all duration-200 group-hover:flex-[0.7]">
            <h3
              className="text-xs lg:text-sm font-semibold text-gray-900 truncate group-hover:max-w-[70%] transition-all duration-200"
              title={folder.name}
            >
              {folder.name}
            </h3>
            <p className="text-[10px] lg:text-xs text-gray-600 truncate mt-0.5">
              {folder.video_count} ວິດີໂອ
              {folder.file_count > 0 && `, ${folder.file_count} ໄຟລ໌`},{" "}
              {folder.subfolder_count} ໂຟລເດີ
            </p>
          </div>
        </div>
        <div className="mt-1.5 lg:mt-2 flex items-center justify-between">
          <span className="text-xs text-gray-500 truncate">
            {new Date(folder.created_at).toLocaleDateString()}
          </span>
          <div className="flex items-center space-x-1 opacity-0 group-hover:opacity-100 transition-all duration-200 flex-shrink-0 w-0 group-hover:w-auto overflow-hidden transform group-hover:scale-100 scale-95">
            <button
              onClick={(e) => {
                e.stopPropagation();
                onEdit(folder);
              }}
              className="text-gray-500 hover:text-indigo-600 p-1 rounded-md hover:bg-indigo-50 transition-all duration-200 group/edit"
              title="ປ່ຽນຊື່ໂຟລເດີ"
              aria-label="ປ່ຽນຊື່ໂຟລເດີ"
            >
              <div className="relative">
                <PencilIcon className="h-3 w-3 lg:h-4 lg:w-4 transition-all duration-200 group-hover/edit:scale-110" />
                <div className="absolute inset-0 bg-indigo-100 rounded-full opacity-0 group-hover/edit:opacity-20 transition-opacity duration-200"></div>
              </div>
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onMove(folder);
              }}
              className="text-gray-500 hover:text-blue-600 p-1 rounded-md hover:bg-blue-50 transition-all duration-200 group/move"
              title="ຍ້າຍໂຟລເດີ"
              aria-label="ຍ້າຍໂຟລເດີ"
            >
              <div className="relative">
                <ArrowUpTrayIcon className="h-3 w-3 lg:h-4 lg:w-4 transition-all duration-200 group-hover/move:scale-110" />
                <div className="absolute inset-0 bg-blue-100 rounded-full opacity-0 group-hover/move:opacity-20 transition-opacity duration-200"></div>
              </div>
            </button>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onDelete(folder);
              }}
              className="text-gray-500 hover:text-red-600 p-1 rounded-md hover:bg-red-50 transition-all duration-200 group/delete"
              title="ລຶບໂຟລເດີ"
              aria-label="ລຶບໂຟລເດີ"
            >
              <div className="relative">
                <TrashIcon className="h-3 w-3 lg:h-4 lg:w-4 transition-all duration-200 group-hover/delete:scale-110" />
                <div className="absolute inset-0 bg-red-100 rounded-full opacity-0 group-hover/delete:opacity-20 transition-opacity duration-200"></div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FolderCard;
